import axios from 'axios';

// config.js
const IMAGES_HOST = process.env.REACT_APP_IMAGES_HOST || 'https://storage.googleapis.com/dcc-ventas-imagenes';
const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://0.0.0.0:9000';
const WHATSAPP_BASE_URL = process.env.REACT_APP_WHATSAPP_BASE_URL || 'http://0.0.0.0:3001';
const IMAGES_AI_BASE_URL = process.env.REACT_APP_IMAGES_AI_BASE_URL || 'http://0.0.0.0:9100';
const IA_SERVICE_BASE_URL = process.env.REACT_APP_IA_SERVICE_BASE_URL || 'http://localhost:8080';

export const authConfig = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID, 
  //audience: 'your-api-audience',
};

var loading = false;

const API = axios.create({
  baseURL: BASE_URL,
});

const WHATSAPP_API = axios.create({
  baseURL: WHATSAPP_BASE_URL,
});

const IMAGES_AI_API = axios.create({
  baseURL: IMAGES_AI_BASE_URL,
});

const IA_SERVICE_API = axios.create({
  baseURL: IA_SERVICE_BASE_URL,
});

WHATSAPP_API.interceptors.request.use(
  (config) => {
      loading = true;
    return config;
  },
  (error) => {
    loading = false;
    return Promise.reject(error);
  }
);

WHATSAPP_API.interceptors.response.use(
  (response) => {
    loading = false;
    return response;
  },
  (error) => {
    loading = false;
    return Promise.reject(error);
  }
);

API.interceptors.request.use(
  (config) => {
      loading = true;
    return config;
  },
  (error) => {
    loading = false;
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    loading = false;
    return response;
  },
  (error) => {
    loading = false;
    return Promise.reject(error);
  }
);

export {
  API,
  IMAGES_HOST,
  WHATSAPP_API,
  IMAGES_AI_API,
  IA_SERVICE_API,
  loading
}
